export const CategoryEndpoint = {
  CATEGORY_LIST_URL: "category", /* for get post patch */
  
};
export const ServiceEndpoint={
SERVICES_LIST_URL:"service/list?type=Services",
SERVICE_CREATE:"service/create",
SERVICE_UPDATE:"service/update/",
  ADDONS_LIST_URL:"service/list?type=Addons",
  ADDONS_UPDATE:"service/update/",
  ADDONS_CREATE:"service/create",
  PROVIDERS_LIST_URL: "providers/list"
}